<template>
  <div>
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="120"
      >
        <template slot-scope="scope">
          <LicensePlate
            v-if="scope.row.company_vehicle != undefined"
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alpha"
          ></LicensePlate>
        </template>
      </el-table-column>

      <el-table-column align="center" :label="$t('DRIVER_TITLE')" width="120">
        <template slot-scope="scope">
          <div :data-title="$t('DRIVER_TITLE')">
            {{
              scope.row.driver &&
              scope.row.driver.first_name + ' ' + scope.row.driver.last_name
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TIME')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TIME')" class="flex flex-col">
            <div class="flex flex-col gap-1">
              <span>
                {{
                  new Date(scope.row.start_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.start_datetime).toLocaleDateString('fa-IR')
                }}
              </span>

              <span v-if="scope.row.end_datetime">
                {{
                  new Date(scope.row.end_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.end_datetime).toLocaleDateString('fa-IR')
                }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('GEOFENCE')"
        width="100"
      >
        <template slot-scope="scope">
          <div :data-title="$t('GEOFENCE')">
            <span>
              {{
                scope.row.fence.title != '' ? scope.row.fence.title : $t('VIEW')
              }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        width="100"
      >
        <template slot-scope="scope">
          <a
            :href="'../reports/geofence-rules/' + scope.row.id"
            class="text-carpo"
          >
            {{ $t('VIEW_DETAIL') }}
          </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import LicensePlate from '@/components/cars/LicensePlate'

export default {
  props: ['tableData', 'loading', 'type', 'alpha'],
  components: {
    LicensePlate,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
